import { formatDuration } from "@enos-monorepo/lib";

interface TotalAmountProps {
  totalAmount: number; // coming in minutes
}

export function TotalAmount({ totalAmount }: TotalAmountProps) {
  const styles = {
    0: {
      border: "border-[#F6B100]",
      text: "#DFA000",
      background: "#FFF8DD",
    },
    1: {
      border: "border-[#17C653]",
      text: "#25AF54",
      background: "#EAFFF1",
    },
    2: {
      border: "border-[#F8285A]",
      text: "#D81A48",
      background: "#FFEEF3",
    },
  };

  const getStyle = () => {
    if (totalAmount / 60 === 0) return styles[0];
    if (totalAmount / 60 > 48) return styles[2];
    return styles[1];
  };

  const { border, text, background } = getStyle();

  return (
    <div
      className={`border ${border} border-opacity-20 text-[13px] rounded-[4px] py-[9px] px-[11px]`}
      style={{ backgroundColor: background, color: text }}
    >
      <span>{formatDuration(totalAmount)}</span>
    </div>
  );
}
